import axios from "axios";
import { BASE_URL } from "./Constants";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export async function searchPerso(searchInput) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.get(`/persos/search?q=${searchInput}`);

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function searchDico(searchInput) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.get(`/dicos/search?q=${searchInput}`);

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function searchSerie(searchInput) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.get(`/series/search?q=${searchInput}`);

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function searchCollection(searchInput) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.get(`/collection/search?q=${searchInput}`);

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}
